import { createClient } from '@supabase/supabase-js'

// Sadece authentication için kullanılır
// Tüm data işlemleri  /api/* endpoint'leri üzerinden yapılır

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!supabaseUrl) {
  throw new Error("Missing REACT_APP_SUPABASE_URL environment variable")
}
if (!supabaseAnonKey) {
  throw new Error("Missing REACT_APP_SUPABASE_ANON_KEY environment variable")
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
